<t-llevo-dialog-header
  dialogTitle="Editar versión"
  mat-dialog-title
></t-llevo-dialog-header>

<mat-dialog-content commonui-loader [appLoader]="loading()?? false">
  <form [formGroup]="frm" class="formGroup">
    <mat-form-field>
      <mat-label>Código de versión</mat-label>
      <input matInput formControlName="versionCode" #firstInput/>
      @if(versionCode.hasError('required')){
      <mat-error>Campo requerido</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Nombre de versión</mat-label>
      <input matInput formControlName="versionName" />
      @if(versionName.hasError('required')){
      <mat-error>Campo requerido</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Enlace de descarga</mat-label>
      <input matInput formControlName="urlDownload" />
      @if(urlDownload.hasError('required')){
      <mat-error>Campo requerido</mat-error>
      } @else if(urlDownload.hasError('pattern')){
      <mat-error>Formato de enlace incorrecto</mat-error>
      }
    </mat-form-field>

    <mat-checkbox formControlName="required">Actualización obligatoria</mat-checkbox>

    <mat-form-field>
      <mat-label>Descripción</mat-label>
      <textarea matInput formControlName="description"></textarea>
      @if(description.hasError('required')){
      <mat-error>Campo requerido</mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close>Cancelar</button>
  <button
    mat-flat-button
    (click)="onSubmit()"
    [disabled]="frm.invalid || frm.pristine || (loading() ?? false)"
    color="accent"
  >
    Guardar cambios
  </button>
</mat-dialog-actions>
